import React from 'react';
import styled from '@emotion/styled';
import Results, { ResultItem } from '../Symbols/Results';

const ResultNumber = styled('span')`
	font-style: italic;
	text-align: right;
`;

export default function StyledResult({ retirement }) {
	return (
		<Results data-cy="result">
			<ResultItem name="Váš důchodový věk je:">
				<ResultNumber>{retirement.retirementAge}</ResultNumber>
			</ResultItem>
			<ResultItem name="Odchod do důchodu:">
				<ResultNumber>{retirement.retirementDate}</ResultNumber>
			</ResultItem>
			<ResultItem name="Do důchodového věku vám zbývá:">
				<ResultNumber>{retirement.retirementRemains}</ResultNumber>
			</ResultItem>
		</Results>
	);
}
